import { createSlice } from "@reduxjs/toolkit";
import { SocialMediaState } from "./types";

export const initialState: SocialMediaState = {
  instagramLoading: false,
  instagramError: false,
  facebookLoading: false,
  facebookError: false,
  youtubeLoading: false,
  youtubeError: false,
};

export const socialMediaSlice: any = createSlice({
  name: "socialMedia",
  initialState,
  reducers: {
    // Instagram actions
    uploadToInstagram: (state) => {
      state.instagramLoading = true;
    },
    uploadToInstagramSuccess: (state, action) => {
      state.instagramLoading = false;
    },
    uploadToInstagramFailed: (state) => {
      state.instagramLoading = false;
      state.instagramError = true;
    },

    // Facebook actions
    uploadToFacebook: (state) => {
      state.facebookLoading = true;
    },
    uploadToFacebookSuccess: (state, action) => {
      state.facebookLoading = false;
    },
    uploadToFacebookFailed: (state) => {
      state.facebookLoading = false;
      state.facebookError = true;
    },

    // YouTube actions
    uploadToYouTube: (state) => {
      state.youtubeLoading = true;
    },
    uploadToYouTubeSuccess: (state, action) => {
      state.youtubeLoading = false;
    },
    uploadToYouTubeFailed: (state) => {
      state.youtubeLoading = false;
      state.youtubeError = true;
    },
  },
});

export const {
  uploadToInstagram,
  uploadToInstagramSuccess,
  uploadToInstagramFailed,
  uploadToFacebook,
  uploadToFacebookSuccess,
  uploadToFacebookFailed,
  uploadToYouTube,
  uploadToYouTubeSuccess,
  uploadToYouTubeFailed,
} = socialMediaSlice.actions;

export default socialMediaSlice.reducer;

